import React from 'react';
import { UserCog, BookOpen, Users, ArrowLeft, QrCode, ShieldCheck } from 'lucide-react';

// ✅ IMPORTACIONES CORREGIDAS CON RUTAS ABSOLUTAS
import { useAuth } from 'context/AuthContext';
import { branding } from 'theme/designSystem';

const ProfileSelection = ({ alVolver }) => {
  const { loginAnonimo, loading } = useAuth();

  const perfiles = [
    {
      id: 'admin',
      titulo: 'Administración',
      descripcion: 'Control total de la torre, auditorías y staff.',
      icon: <UserCog size={36} />,
      color: branding.casaDeFe.primario,
      delay: 'delay-75'
    },
    {
      id: 'recepcion',
      titulo: 'Recepción',
      descripcion: 'Registro sanitario e impresión de tickets QR.',
      icon: <QrCode size={36} />,
      color: '#F59E0B', // Ámbar de alerta/recepción
      delay: 'delay-100'
    },
    {
      id: 'maestro',
      titulo: 'Maestro',
      descripcion: 'Torre de control de salón y radar de salud.',
      icon: <BookOpen size={36} />,
      color: '#10B981', // Verde de seguridad
      delay: 'delay-150'
    },
    {
      id: 'padre',
      titulo: 'Padre / Tutor',
      descripcion: 'Ficha de registro, estrellas y carnet digital.',
      icon: <Users size={36} />,
      color: '#6366F1', // Indigo de familia
      delay: 'delay-200'
    }
  ];

  const manejarSeleccion = async (rol) => {
    // Iniciamos sesión anónima pasando el rol elegido
    await loginAnonimo(rol);
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center p-6 bg-slate-50 relative overflow-hidden font-sans text-left">
      
      {/* BARRA DE PROGRESO DE LOGIN */}
      {loading && (
        <div className="fixed top-0 left-0 w-full h-1.5 bg-slate-200 overflow-hidden z-[100]">
          <div className="w-full h-full bg-indigo-600 animate-progress origin-left"></div>
        </div>
      )}

      {/* BOTÓN VOLVER (ESTILO GHOST) */}
      <button 
        onClick={alVolver}
        disabled={loading}
        className="absolute top-10 left-10 flex items-center gap-2 text-slate-400 hover:text-indigo-600 transition-all font-black text-[10px] uppercase tracking-[0.3em] disabled:opacity-50 group"
      >
        <ArrowLeft size={18} className="group-hover:-translate-x-2 transition-transform" /> 
        Salir del Portal
      </button>

      <div className="max-w-7xl w-full">
        <div className="text-center mb-16 animate-in fade-in slide-in-from-top-6 duration-1000">
          <div className="inline-block p-4 bg-indigo-50 rounded-[2rem] mb-6">
             <ShieldCheck size={40} className="text-indigo-600" />
          </div>
          <h2 className="text-5xl md:text-7xl font-black tracking-tighter text-slate-900 mb-4 italic leading-none uppercase">
            Acceso <span style={{ color: branding.casaDeFe.primario }}>IgleKids</span>
          </h2>
          <p className="text-slate-400 font-bold uppercase tracking-[0.4em] text-[11px] italic">
            Selecciona tu perfil de responsabilidad hoy
          </p>
        </div>

        {/* GRID DE PERFILES ADAPTATIVO */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {perfiles.map((perfil) => (
            <button
              key={perfil.id}
              onClick={() => manejarSeleccion(perfil.id)}
              disabled={loading}
              className={`group relative bg-white p-10 rounded-[4rem] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border-4 border-slate-50 flex flex-col items-center text-center transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl hover:border-indigo-100 animate-in fade-in zoom-in-95 ${perfil.delay} disabled:opacity-50`}
            >
              {/* Círculo de Icono */}
              <div 
                className="w-24 h-24 rounded-[2.5rem] flex items-center justify-center mb-8 transition-all duration-500 group-hover:scale-110 group-hover:rotate-12 shadow-inner"
                style={{ backgroundColor: `${perfil.color}10`, color: perfil.color }}
              >
                {perfil.icon}
              </div>

              <h3 className="text-xl font-black text-slate-800 mb-3 tracking-tighter uppercase italic leading-none">
                {perfil.titulo}
              </h3>
              
              <p className="text-[11px] text-slate-400 leading-relaxed font-bold uppercase tracking-widest italic opacity-80">
                {perfil.descripcion}
              </p>

              <div 
                className="mt-10 opacity-0 group-hover:opacity-100 transition-all duration-300 font-black text-[10px] uppercase tracking-[0.4em] flex items-center gap-2 translate-y-4 group-hover:translate-y-0"
                style={{ color: perfil.color }}
              >
                Entrar ahora <ArrowLeft size={14} className="rotate-180" />
              </div>
              
              {/* BARRA DE COLOR INFERIOR DINÁMICA */}
              <div 
                className="absolute bottom-6 left-1/2 -translate-x-1/2 w-8 h-1.5 opacity-20 group-hover:w-24 group-hover:opacity-100 transition-all duration-700 rounded-full"
                style={{ backgroundColor: perfil.color }}
              />
            </button>
          ))}
        </div>
      </div>

      {/* FOOTER DE VERSIONAMIENTO */}
      <div className="mt-24 flex flex-col items-center gap-3 opacity-20 grayscale transition-all hover:opacity-100 hover:grayscale-0">
        <div className="flex items-center gap-2">
           <div className="h-0.5 w-8 bg-indigo-500" />
           <span className="text-[10px] font-black tracking-[0.5em] uppercase text-slate-900">
             Casa de Fe
           </span>
           <div className="h-0.5 w-8 bg-indigo-500" />
        </div>
        <span className="text-[8px] font-bold text-slate-500 uppercase tracking-widest">
          Sistema de Seguridad Infantil • v3.0 stable
        </span>
      </div>
    </div>
  );
};

export default ProfileSelection;